import React from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const SITE = "https://www.commitmentt.com";
const OG_IMAGE = `${SITE}/og-cover.jpg`;

export default function Seo({ title, description, noindex = false }) {
  const { pathname } = useLocation();
  const canonical = `${SITE}${pathname === "/" ? "" : pathname}`;
  const fullTitle = title ? `${title} · COMMITMENTT` : "COMMITMENTT — Know what your salary is committed to";
  const desc = description || "COMMITMENTT brings subscriptions, EMIs, BNPL dues, bills and autopays into one calm view so you can see what your income is already committed to.";
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={canonical} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="COMMITMENTT" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={OG_IMAGE} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={OG_IMAGE} />
    </Helmet>
  );
}
